import { render, staticRenderFns } from "./UpgradeBox.vue?vue&type=template&id=4edeaee7&scoped=true"
import script from "./UpgradeBox.vue?vue&type=script&lang=js"
export * from "./UpgradeBox.vue?vue&type=script&lang=js"
import style0 from "./UpgradeBox.vue?vue&type=style&index=0&id=4edeaee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edeaee7",
  null
  
)

export default component.exports